export default "__VITE_ASSET__nqmre1TI__"